const HickoryHoedown = {
    name: "Hickory Hoedown",
    bpm: 104,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default HickoryHoedown;